<template>
  <div style="background-image: url('/img/videoPageBg.png');background-size: 100%;width: 100vw;height: 100vh;overflow: auto;">
    <div>
      <van-nav-bar title="订单确认" fixed class="nav-bar">
        <template #left>
          <img src="/img/logo.png" width="100px" />
        </template>
        <template #title>
          <h1 class="vux-header-title">
            <div class="top_nav"
              style="border-top: 1px solid rgb(172, 98, 204); border-bottom: 1px solid rgb(172, 98, 204);">
              <span @click="active = 1" :class="{ active: active == 1 }" style="border-left: 1px solid rgb(172, 98, 204);"
                :style="{ background: active == 1 ? 'rgb(172, 98, 204)' : null }">
                指南针
              </span>
              <span @click="active = 2" :class="{ active: active == 2 }" style="border-right: 1px solid rgb(172, 98, 204);"
                :style="{ background: active == 2 ? 'rgb(172, 98, 204)' : null }">
                性福射
              </span>
            </div>
          </h1>
        </template>
      </van-nav-bar>
    </div>
    <div class="hr"></div>
    <div class="tabContent1" v-if="active==1">
      <div class="banner-swiper">
        <div class="swiper">
          <van-swipe autoplay="5000" loop>
            <van-swipe-item v-for="item in bannerList" :key="item.id">
              <img style="width:100%;height:100%;object-fit: cover;" :src="$baseURL + item.url" />
            </van-swipe-item>
          </van-swipe>
        </div>
      </div>
      <div class="vw_black" @click="$refs.noticeDetailPop.show(noticeNew)">
        <van-notice-bar color="#ff4d67" background="#fff" left-icon="volume-o" :text="noticeNew.name||'欢迎使用'" />
      </div>
      <div class="quickBox"><div class="text"><p>欢迎来到及时‘’性‘’乐！</p> <p>{{userInfo.username}}</p></div> <!----></div>
      <div><div class="hot_lottery"><div><img src="/img/hotlotteryimg.png" alt="" style="width: 100%;"></div></div></div>
      <div>
        <div class="fuli" v-for="item_videoClass in videoClass['分类']" :key="item_videoClass.id">
          <div class="title">{{ item_videoClass.name }}</div>
          <div class="flBox">
            <div class="item" @click="toPlayVideo(item_video.id)" v-for="item_video in item_videoClass.videoList" :key="item_video.id"><img :src="item_video.vod_pic" alt=""> <p>{{item_video.vod_name}}</p></div>
          </div>
        </div>
      </div>
    </div>
    <div class="tabContent12" v-if="active==2">
      <div>
        <div class="tabbar">
          <div class="tabbar-itme">
            <div @click="onChangeType('default')" :class="{active:type=='default'}">全部</div>
            <div v-for="item in videoClass['分类']" :key="item.id" @click="onChangeType(item.id)" :class="{active:type==item.id}">{{ item.name }}</div>
          </div>
          <div class="tabbar-itme">
            <div @click="onChangeArea('default')" :class="{active:area=='default'}">全部</div>
            <div v-for="item in videoClass['地区']" :key="item.id" @click="onChangeArea(item.id)" :class="{active:area==item.id}">{{ item.name }}</div>
          </div>
          <div class="tabbar-itme">
            <div @click="onChangeTag('default')" :class="{active:tag=='default'}">全部</div>
            <div v-for="item in videoClass['标签']" :key="item.id" @click="onChangeTag(item.id)" :class="{active:tag==item.id}">{{ item.name }}</div>
          </div>
          <div class="tabbar-itme">
            <div @click="onChangeOrder('default')" :class="{active:order=='default'}">全部</div>
            <div @click="onChangeOrder('desc')" :class="{active:order=='desc'}">最高评分</div>
            <div @click="onChangeOrder('asc')" :class="{active:order=='asc'}">最低评分</div>
          </div>
        </div>
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
          <div style="text-align: center;line-height: 50px;" v-show="data.length==0">暂无相关视频</div>
          <van-list v-model="loading" :finished="finished" @load="onLoad">
            <div class="fuli">
              <div class="flBox">
                <div class="item" @click="toPlayVideo(item_video.id)" v-for="item_video in data" :key="item_video.id"><img :src="item_video.vod_pic" alt=""> <p>{{item_video.vod_name}}</p></div>
              </div>
            </div>
          </van-list>
        </van-pull-refresh>
      </div>
    </div>
    <noticeDetailPop ref="noticeDetailPop"></noticeDetailPop>
    <div style="height: 55px;"></div>
  </div>
</template>

<script>
import noticeDetailPop from '@/pages/notice/noticeDetailPop.vue'
export default {
  components:{noticeDetailPop},
  data() {
    return {
      active: 1,
      bannerList: [],
      userInfo: {
      },
      navSel: 0,
      navSel2: 0,
      list: [],
      // 修改 nav2list 结构，添加 value 用于请求参数
      nav2list: [
        { text: this.$t('q55'), value: 'default' },      // 默认排序（不需要点击事件）
        { text: this.$t('q56'), value: 'desc' },        // 播放次数由高到低
        { text: this.$t('q57'), value: 'asc' }          // 播放次数由低到高
      ],
      loading: false,
      finished: false,
      refreshing: false,
      videoClass: [],
      data: [],
      page: 0,
      id: 888,
      type:'default',
      area:'default',
      tag:'default',
      order: 'default', // 排序方式
      noticeNew:{}
    };
  },
  methods: {
    getUserInfo() {
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res => {
        if (res.code === 200) {
          this.userInfo = res.data;
          if (this.userInfo.status !== 1) {
            this.$toast(this.$t("video.account_out"));
            localStorage.clear()
            this.$router.push({ path: '/Login' })
          }
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      })
    },
    getBannerList() {
      this.$http({
        method: "get",
        url: "getBannerList",
      }).then((res) => {
        this.bannerList = res.data
      });
    },
    onLoad(isRefresh = false) {
      if (isRefresh) {
        this.page = 0;
        this.data = [];
      }

      this.loading = true;

      this.getVideoList().then(() => {
        this.loading = false;
        if (this.refreshing) {
          this.refreshing = false;

        }
      });
    },

    // 第一个导航：分类切换
    onChangeCategory(categoryId, index) {
      this.id = categoryId;
      this.navSel = index;
      this.resetAndLoad();
    },

    onChangeType(val) {
      this.type = val;
      this.resetAndLoad();
    },
    onChangeArea(val) {
      this.area = val;
      this.resetAndLoad();
    },
    onChangeTag(val) {
      this.tag = val;
      this.resetAndLoad();
    },
    onChangeOrder(orderType) {
      this.order = orderType;
      this.resetAndLoad();
    },

    // 统一的重置和加载方法
    resetAndLoad() {
      this.finished = false;
      this.loading = true;
      this.page = 0;
      this.data = [];
      this.onLoad(true);
    },

    onRefresh() {
      // 清空列表数据
      this.finished = false;
      this.loading = true;
      this.onLoad(true);
    },

    toPlayVideo(id) {
      this.$router.push({ path: "/PlayVideo", query: { id } });
    },

    getVideoList() {
      return new Promise((resolve, reject) => {
        console.log('发送请求，页码:', this.page, '分类:', this.id, '排序:', this.order);

        const pageToSend = this.page + 1;

        // 构建请求参数
        const requestData = {
          page: pageToSend
        };

        // 只有当order不是默认值时才添加order参数
        if (this.type !== 'default') {
          requestData.class_id = this.type;
        }
        if (this.area !== 'default') {
          requestData.area_id = this.area;
        }
        if (this.tag !== 'default') {
          requestData.tag_id = this.tag;
        }
        if (this.order !== 'default') {
          requestData.order = this.order;
        }

        this.$http({
          method: "get",
          data: requestData,
          url: "video_list",
        }).then((res) => {
          if (res.data && res.data.data && res.data.data.length > 0) {
            this.data = this.data.concat(res.data.data);
            this.page++;
            resolve();
          } else {
            this.finished = true;
            resolve();
          }
        }).catch((error) => {
          console.error("Error fetching video list:", error);
          reject(error);
        });
      });
    },

    toLogin(str) {
      this.$router.push({ path: str });
    },

    getVideoClass() {
      this.$http({
        method: "get",
        url: "video_class",
      }).then((res) => {
        // 直接使用后端返回的数据
        this.videoClass = res.data;
        this.videoClass['分类'].forEach(item=>{
          const requestData = {
            id: item.id,
            page: 1
          };
          this.$http({
            method: "get",
            data: requestData,
            url: "video_list",
          }).then((res) => {
            res.data.data.forEach(v=>{
              if(v.vod_pic.indexOf('http://')==-1&&v.vod_pic.indexOf('https://')==-1){
                v.vod_pic=this.$baseURL+v.vod_pic
              }
            })
            this.$set(item,'videoList',res.data.data)
          })
        })
        // 如果需要添加"最新"选项，确保是单一语言
        // 可以根据需要选择固定的语言，比如中文
        // const obj = { id: 888, name: "最新" };
        // this.videoClass.unshift(obj);
      });
    }
  },
  created() {
    this.getUserInfo();
    this.getVideoClass();
    this.getBannerList()
    this.$http({
        method: 'get',
        url: 'getNoticeNew'
    }).then(res=>{
      if(res.code==200){
        this.noticeNew=res.data
      }
    })
  },
};
</script>


<style scoped lang="less">
/deep/ .van-tabs__nav {
  background: #fff;
}

/deep/ .van-nav-bar__title {
  color: #333 !important;
}

.van-nav-bar {
  background: #fff;
  border-bottom-width: 0;

  img {
    height: 60px;
  }

  .vux-header-title {
    line-height: 80px;
    text-align: center;
    font-size: 36px;
    font-weight: 400;
    color: #fff;
  }

  .vux-header-title {
    margin: 0 5.5rem;
    height: 80px;
    width: 236px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    margin: auto;
    bottom: 0;
  }

  .vux-header-title {
    font-size: 40px;
    color: #333;
  }

  .top_nav {
    height: 52px;
    line-height: 52px;
    border-top: 2px solid #ff4d67;
    border-bottom: 2px solid #ff4d67;
    border-radius: 28px;
    width: 236px;
    margin: 12px auto;
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: space-evenly;
    -webkit-justify-content: space-evenly;
    justify-content: space-evenly;

    span {
      font-size: 26px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #333;
      -webkit-box-flex: 1;
      -webkit-flex: 1;
      flex: 1;

      &:first-child {
        border-left: 2px solid #ff4d67;
        border-top-left-radius: 26px;
        border-bottom-left-radius: 26px;
      }

      &:last-child {
        border-right: 2px solid #ff4d67;
        border-top-right-radius: 26px;
        border-bottom-right-radius: 26px;
      }
    }

    .active {
      color: #fffefe;
      background: #ff4d67;
    }
  }
}

.hr {
  height: 100px
}

.banner-swiper {
  padding: 4px 20px;
  /* 0.125×32=4, 0.625×32=20 */
  background: #f2f2f2;

  .swiper {
    padding: 4px 0 !important;
    /* 0.125×32=4 */
    background: #f2f2f2;
    border-radius: 36px;
    /* 1.125×32=36 */
    box-shadow: 0 4px 2px #655c4b;
    /* 0.125×32=4, 0.0625×32=2 */
    height: 300px;
    overflow: hidden;

    img {
      height: 300px !important;
    }
  }
}

.quickBox {
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    justify-content: space-between;
    padding: 40px 30px;
    p {
    font-family: PingFang SC;
    font-weight: 500;
    color: #333;
    line-height: 1;
    font-size: 24px;
}
p:last-child {
    padding-top: 20px;
    font-size: 36px;
}
}
.hot_lottery {
    padding: 0 30px;
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-flex-wrap: wrap;
    flex-wrap: wrap;
}
.fuli{
  .title {
    box-sizing: content-box;
    height: 58px;
    line-height: 50px;
    font-size: 24px;
    font-weight: bold;
    color: #fff;
    padding: 38px 30px;
    text-indent: 30px;
    min-width: 132px;
    background: url(data:image/png;base64,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) no-repeat;
    background-size: 162px 58px;
    background-position: 30px center;
}
.flBox {
    font-size: 0;
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-flex-wrap: wrap;
    flex-wrap: wrap;
    padding: 0 30px;
     .item:nth-child(odd) {
    margin-right: 14px;
}
.item:nth-child(even) {
    margin-left: 14px;
}
.item img {
    width: 330px;
    height: 185px;
    border-radius: 12px;
}
.item p {
    width: 330px;
    height: 55px;
    line-height: 55px;
    text-align: center;
    font-size: 24px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #000;
}
}
}
.tabbar{
  background-color: #fff;
  .tabbar-itme{
    height: 80px;
    overflow-x: auto;
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    >div{
      flex-shrink: 0;
      margin-left: 20px;
      padding: 10px 20px;
      color: #333;
      font-size: 28px;
      &.active{
        background-color: #ff4d67;
        color: #fff;
        border-radius: 40px;
      }
    }
  }
}
.video_box {
  padding-top: 100px;

  /deep/ .van-tabs__nav {
    background: linear-gradient(120deg, #212121, #313131);
    border-top: 1px solid #333;
    border-bottom: 1px solid #333;
  }

  .nav_box_w {
    display: flex;
    background: linear-gradient(120deg, #212121, #313131);
    padding: 20px;
    border-top: 1px solid #333;
    border-bottom: 1px solid #333;
    flex-wrap: wrap;

    .n_item {
      color: #fff;
      padding: 2px 16px;
      border-radius: 40px;
      margin-right: 20px;

      &.active {
        background: linear-gradient(90deg, #efcba7, #dcab76);
        color: #623a13;

      }
    }
  }

  .c_yy {
    width: 100%;
    overflow: hidden;
    /* 确保超出容器的内容被裁剪 */
    white-space: nowrap;
    /* 确保文本在一行内显示 */
    text-overflow: ellipsis;
    /* 超出部分显示省略号 */
    color: #c7c7c7;
    font-size: 30px;
    padding: 12px 0 30px;
  }

  .movie-list-item {
    .imb_box {
      position: relative;

      .van_img {
        height: 300px;
        width: 100%;
        border-radius: 20px;
      }

      .cc_zan {
        position: absolute;
        background: rgba(0, 0, 0, 0.5);
        border-radius: 20px 0;
        color: #fff;
        bottom: 26px;
        right: 26px;
        font-size: 24px;
        padding: 2px 16px;
      }
    }
  }
}

/deep/ .van-tabs__wrap {
  height: 13vw;
  padding-bottom: 10px;
}

/deep/ .van-tabs__line {
  background-color: #c571cf;
}

/deep/ .van-loading__text {
  font-size: 32px;
  color: #000;

}

/deep/ .van-list__finished-text {
  font-size: 32px;
  color: #000;

}

/deep/ .van-pull-refresh__head {
  height: 100px;
}

/deep/ .van-pull-refresh__text {
  font-size: 32px;
  /* 设置字体大小 */
  color: #000;

}

.list-item {
  display: flex;
  width: calc(100% - 7vw);
  margin: 10px auto;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;
}

.movie-list-item {
  width: calc(50% - 12px);

}

.cover_img {
  border-radius: 20px;
}

.movie-list-item-bottom {
  position: relative;
  width: 100%;
  bottom: 6vw;
}

.movie-time-div {
  background-color: rgba(0, 0, 0, 0.4);
  height: 8vw;
  color: #fff;
  border-radius: 0 0 40px 40px;
}

.movie-list-item-bottom div {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.movie-time-div span:first-child {
  overflow: hidden;
  white-space: nowrap;
  width: 24vw;
  padding-left: 16px;
  font-size: 3vw;
}

.activeBg {
  color: rgb(197, 113, 207);
  font-weight: bold;
  background: url('/img/new.png') right top 5px / 30% no-repeat;
}
</style>
